import {
  OrderStatus,
  PaymentProviders,
  PaymentStatus,
} from "@shared_packages/toolkit/types";
import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../components/advanced-search/AdvancedSearch.interface";
import { currencyConfig } from "../../../../constants/currencies";

export const ordersSearchConfig: ISearchFieldConfig[] = [
  {
    type: SearchFieldType.AMOUNT_RANGE,
    label: "Price",
    key: "totalFrom",
    rangeEndKey: "totalTo",
    placeholder: "Amount from",
    rangeEndPlaceholder: "Amount to",
  },
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Created date",
    key: "from",
    rangeEndKey: "to",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  {
    type: SearchFieldType.SEARCH_BY_USER_DROPDOWN,
    label: "Created by",
    key: "createdBy",
  },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Order status",
    key: "status",
    dropdownValues: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Draft",
        value: OrderStatus.DRAFT,
      },
      {
        label: "Awaiting payment",
        value: OrderStatus.AWAITING_PAYMENT,
      },
      {
        label: "Preparation",
        value: OrderStatus.PREPARATION,
      },
      {
        label: "Awaiting delivery",
        value: OrderStatus.AWAITING_DELIVERY,
      },
      {
        label: "Delivery in progress",
        value: OrderStatus.DELIVERY_IN_PROGRESS,
      },
      {
        label: "Delivered",
        value: OrderStatus.DELIVERED,
      },
      {
        label: "Delivery failure",
        value: OrderStatus.DELIVERY_FAILURE,
      },
      {
        label: "Cancelled",
        value: OrderStatus.CANCELLED,
      },
      {
        label: "Return in progress",
        value: OrderStatus.RETURN_IN_PROGRESS,
      },
      {
        label: "Returned",
        value: OrderStatus.RETURNED,
      },
      {
        label: "Redespatch",
        value: OrderStatus.REDESPATCH,
      },
      {
        label: "Redespatch in progress",
        value: OrderStatus.REDESPATCH_DELIVERY_IN_PROGRESS,
      },
      {
        label: "Redespatch delivered",
        value: OrderStatus.REDESPATCH_DELIVERED,
      },
      {
        label: "Redespatch failure",
        value: OrderStatus.REDESPATCH_DELIVERY_FAILURE,
      },
      {
        label: "Refunded",
        value: OrderStatus.REFUNDED,
      },
      {
        label: "Return requested",
        value: OrderStatus.RETURN_REQUESTED,
      },
      {
        label: "Refund requested",
        value: OrderStatus.REFUND_REQUESTED,
      },
    ],
  },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Payment status",
    key: "paymentStatus",
    dropdownValues: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Draft",
        value: PaymentStatus.DRAFT,
      },
      {
        label: "Cancelled",
        value: PaymentStatus.CANCELLED,
      },
      {
        label: "Overdue",
        value: PaymentStatus.OVERDUE,
      },
      {
        label: "Paid",
        value: PaymentStatus.PAID,
      },
      {
        label: "Partial refund",
        value: PaymentStatus.PARTIAL_REFUND,
      },
      {
        label: "Pending",
        value: PaymentStatus.PENDING,
      },
      {
        label: "Refunded",
        value: PaymentStatus.REFUNDED,
      },
      {
        label: "Refund rejected",
        value: PaymentStatus.REFUND_REJECTED,
      },
      {
        label: "Rejected",
        value: PaymentStatus.REJECTED,
      },
      {
        label: "Sent",
        value: PaymentStatus.SENT,
      },
    ],
  },
  { ...currencyConfig },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Payment type",
    key: "paymentProvider",
    dropdownValues: [
      {
        label: "All",
        value: "",
      },
      {
        label: "Fena Open Banking",
        value: `${PaymentProviders.FENA_OB},${PaymentProviders.FENA_OB_QR},${PaymentProviders.FENA_MOBILE}`,
      },
      {
        label: "Cash",
        value: PaymentProviders.CASH,
      },
      {
        label: "Other",
        value: PaymentProviders.OTHER,
      },
    ],
  },
  {
    type: SearchFieldType.CHECKBOX_ARCHIVED,
    label: "Show archived",
    key: "showDeleted",
  },
];
